export const cilChevronBottom = ["24 24","<path d='M12.003 19.875l-0.535-0.53-4.022-4.022 0.003-0.003-6.698-6.698 4.553-4.553 6.698 6.698 6.698-6.698 4.553 4.553-7.226 7.231zM11.998 17.754l0.003 0.002 2.43-2.43 0.532-0.537 6.168-6.168-2.431-2.431-6.698 6.698-6.698-6.698-2.431 2.431 6.696 6.701z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-chevron-bottom.js
// module id = null
// module chunks = 